export const ZELENA_POSTA_REAUTHORIZE = 'REAUTHORIZE';
